import { render, staticRenderFns } from "./PsotEditMain.vue?vue&type=template&id=71bec33e&scoped=true&"
import script from "./PsotEditMain.vue?vue&type=script&lang=js&"
export * from "./PsotEditMain.vue?vue&type=script&lang=js&"
import style0 from "./PsotEditMain.vue?vue&type=style&index=0&id=71bec33e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bec33e",
  null
  
)

export default component.exports